import { render, staticRenderFns } from "./noNavFooDetail.vue?vue&type=template&id=d63820de"
import script from "./noNavFooDetail.vue?vue&type=script&lang=js"
export * from "./noNavFooDetail.vue?vue&type=script&lang=js"
import style0 from "./noNavFooDetail.vue?vue&type=style&index=0&id=d63820de&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d63820de')) {
      api.createRecord('d63820de', component.options)
    } else {
      api.reload('d63820de', component.options)
    }
    module.hot.accept("./noNavFooDetail.vue?vue&type=template&id=d63820de", function () {
      api.rerender('d63820de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/news/noNavFooDetail.vue"
export default component.exports